import route from 'route';

const mainRoute = route.DASHBOARD;
const auditRoute = `${mainRoute}/audit`;

export default {
  LIST: `${auditRoute}`,
  DETAIL: `${auditRoute}/:id`,
};
